export enum Direction {
  RightToLeft = 'RightToLeft',
  LeftToRight = 'LeftToRight',
}
